// Brand assets (backgrounds removed via flood-fill, served from /public/badges)
export const RPM_LOGO = "/badges/rpm.png";

export const TRUST_BADGES = [
  { src: "/badges/ase.png", alt: "ASE Certified Master Auto Technician" },
  { src: "/badges/icar-platinum.png", alt: "I-CAR Platinum Professional Certified" },
  { src: "/badges/napa.png", alt: "NAPA AutoCare 24 Month / 24,000 Mile Nationwide Warranty" },
  { src: "/badges/aaa.png", alt: "AAA Approved Auto Repair" },
];

export const ADDRESS = "2650 E Alessandro Blvd, Riverside, CA 92508";
